import { put, select } from 'redux-saga/effects';
import { selectStreams, setStreams } from '../../../state/userMedia/userMediaSlice';

export default function* addStream({ payload }) {
  const streams = yield select(selectStreams);
  yield put(setStreams([...streams, payload]));
}
